import React, { useEffect, useState } from 'react';
import { trackFbEvent } from '../utils/fbPixel';
type Plan = 'megapack' | 'megapack-pro';
export function Pricing() {
  const [selected, setSelected] = useState<Plan>('megapack-pro');
  useEffect(() => {
    const section = document.getElementById('pricing');
    if (!section) return;
    const observer = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting) {
        trackFbEvent('ViewContent', {
          content_name: 'Pricing Section',
          content_category: 'Kinesiología Carrera Resuelta'
        });
        observer.disconnect();
      }
    }, {
      threshold: 0.3
    });
    observer.observe(section);
    return () => observer.disconnect();
  }, []);
  const cartUrls: Record<Plan, string> = {
    megapack: 'https://checkout.construyeprogreso.com/cart/48273779458218:1',
    'megapack-pro': 'https://checkout.construyeprogreso.com/cart/48273779523754:1'
  };
  const plans = {
    megapack: {
      emoji: '🦴',
      name: 'MEGAPACK KINESIOLOGÍA CARRERA RESUELTA',
      desc: '6 tomos + 6 bonos · Toda la carrera organizada',
      priceOld: '$58.990',
      priceNew: '$19.990',
      priceColor: 'text-gray-900',
      cta: '→ SÍ, QUIERO EL MEGAPACK',
      sub: '6 tomos · 6 bonos · Acceso inmediato'
    },
    'megapack-pro': {
      emoji: '🏆',
      name: 'MEGAPACK + MÁSTER KINESIOLOGÍA',
      desc: 'Todo el Megapack + el sistema completo para recibirte y arrancar tu práctica profesional.',
      priceOld: '$102.990',
      priceNew: '$27.990',
      priceColor: 'text-blue-700',
      cta: '→ SÍ, QUIERO EL MEGAPACK + MÁSTER KINESIOLOGÍA',
      sub: '6 tomos · 6 bonos · Máster Kinesiología · Acceso inmediato'
    }
  };
  const active = plans[selected];
  return <section id="pricing" className="w-full px-4 sm:px-6 lg:px-8 py-8 text-gray-900" style={{
    background: 'linear-gradient(180deg, rgb(255,255,255) 0%, rgb(239,246,255) 50%, rgb(219,234,254) 100%)'
  }} data-id="element-190">
      <div className="mx-auto max-w-3xl" data-id="element-191">
        {/* Heading */}
        <div className="text-center mb-6" data-id="element-192">
          <div className="inline-flex items-center gap-2 text-[11px] font-bold tracking-wide text-blue-700 border border-blue-700/40 bg-blue-700/5 rounded-full px-4 py-1.5 mb-3" data-id="element-193">
            🔥 Precio de lanzamiento — Sube sin previo aviso
          </div>
          <h2 className="text-2xl sm:text-3xl font-black text-gray-900 m-0 mb-1" data-id="element-194">
            Elegí tu <span className="text-blue-700" data-id="element-195">Megapack:</span>
          </h2>
          <p className="text-xs text-gray-500 m-0" data-id="element-196">
            Las dos opciones incluyen los 6 bonos completos
          </p>
        </div>

        {/* Plan Selector */}
        <div className="flex flex-col gap-2.5 mb-5" data-id="element-197">
          {(Object.keys(plans) as Plan[]).map(plan => {
          const p = plans[plan];
          const isSelected = selected === plan;
          return <button key={plan} onClick={() => setSelected(plan)} className={`w-full text-left rounded-xl p-3.5 transition-all cursor-pointer ${isSelected ? 'border-2 border-blue-700 shadow-lg' : 'border border-gray-200 shadow-sm'}`} style={{
            backgroundColor: isSelected ? 'rgb(239,246,255)' : 'rgb(255,255,255)',
            boxShadow: isSelected ? 'rgba(59,130,246,0.15) 0px 0px 30px 0px' : undefined
          }} data-id="element-198">
                <div className="flex items-center gap-3" data-id="element-199">
                  <div className={`flex h-5 w-5 shrink-0 items-center justify-center rounded-full border-2 ${isSelected ? 'border-blue-700' : 'border-gray-300'}`} data-id="element-200">
                    {isSelected && <div className="h-2.5 w-2.5 rounded-full bg-blue-700" data-id="element-201" />}
                  </div>

                  <div className="flex-1 min-w-0" data-id="element-202">
                    <div className="flex flex-wrap items-center gap-2 mb-0.5" data-id="element-203">
                      <span data-id="element-204">{p.emoji}</span>
                      <span className="text-sm font-black text-gray-900" data-id="element-205">
                        {p.name}
                      </span>
                      {plan === 'megapack-pro' && <span className="bg-blue-700 text-[10px] font-black text-white rounded-full px-2 py-0.5" data-id="element-206">
                          ⭐ MÁS ELEGIDO
                        </span>}
                    </div>
                    <p className="text-xs text-gray-500 m-0" data-id="element-207">{p.desc}</p>
                  </div>

                  <div className="shrink-0 text-right" data-id="element-208">
                    <div className="text-xs text-gray-400 line-through" data-id="element-209">
                      {p.priceOld}
                    </div>
                    <div className={`text-2xl font-black ${p.priceColor}`} data-id="element-210">
                      {p.priceNew}
                    </div>
                  </div>
                </div>
              </button>;
        })}
        </div>

        {/* CTA Block */}
        <div className="rounded-2xl p-4 shadow-lg" style={{
        background: 'linear-gradient(135deg, rgb(29,78,216), rgb(37,99,235))'
      }} data-id="element-211">
          <div className="flex flex-wrap justify-center gap-x-4 gap-y-1 mb-3" data-id="element-212">
            {active.sub.split(' · ').map(item => <span key={item} className="text-[11px] font-bold text-white/90 flex items-center gap-1" data-id="element-213">
                <span className="text-white/60" data-id="element-214">✓</span> {item}
              </span>)}
          </div>

          <a href={cartUrls[selected]} onClick={() => trackFbEvent('InitiateCheckout', {
          content_name: selected === 'megapack-pro' ? 'Megapack + Máster Kinesiología' : 'Megapack Kinesiología Carrera Resuelta',
          content_category: 'Kinesiología Carrera Resuelta',
          value: selected === 'megapack-pro' ? 27990 : 19990,
          currency: 'ARS'
        })} className="block w-full bg-white text-blue-700 text-center text-sm sm:text-base font-black rounded-xl py-3.5 no-underline hover:bg-blue-50 transition-colors" data-id="element-215">
            {active.cta}
          </a>

          <p className="text-center text-[11px] text-white/70 mt-2.5 mb-0" data-id="element-216">
            +1.800 estudiantes ya tienen toda la carrera organizada en un solo
            lugar
          </p>
        </div>

        {/* Trust Badges */}
        <div className="mt-3 flex flex-wrap items-center justify-center gap-3 text-xs text-gray-500 bg-white rounded-xl px-4 py-2.5 shadow-sm border border-gray-100" data-id="element-217">
          <span data-id="element-218">🔒 Pago seguro</span>
          <span data-id="element-219">⚡ Acceso en 5 min</span>
          <span data-id="element-220">🛡️ Garantía 7 días</span>
          <span data-id="element-221">💳 Mercado Pago</span>
        </div>
      </div>
    </section>;
}